import { Module } from 'vuex';

const sidebarModule: Module<any, any> = {
  namespaced: true,

  state: {
    open: false,
  },

  mutations: {
    OPEN_SIDEBAR(state) {
      state.open = true;
    },
    CLOSE_SIDEBAR(state) {
      state.open = false;
    },
  },

  actions: {
    toggle({ dispatch, state }) {
      if (state.open) {
        dispatch('close');
      } else {
        dispatch('open');
      }
    },
    open({ commit }) {
      const openSidebarEvent = new Event('app.sidebar.open');
      window.dispatchEvent(openSidebarEvent);
      commit('OPEN_SIDEBAR');
    },
    close({ commit }) {
      commit('CLOSE_SIDEBAR');
    },
  },

  getters: {
    open: (state) => state.open,
  },
};

export default sidebarModule;
